export default {
  title: '備份設定',
  editButtonText: '編輯設定',
  popupTitle: '編輯備份設定',
  emptyText: '無',
  showErrorText: '取得資料錯誤',
  updateErrorText: '更新錯誤',
  updateSuccessText: '成功更新',
  backupDaysMaxErrorText: '備份範圍需小於等於紀錄保留天數',
  backupDaysMinErrorText: '備份範圍需大於等於備份頻率',
  nextBackupCard: {
    title: '下次備份',
    icon: 'icon-refresh',
  },
  cards: [
    {
      id: 'retentionDays',
      type: 'number',
      unit: '天',
      title: '紀錄保留天數',
      icon: 'icon-time',
      description: '操作記錄在系統中保存的天數',
      warning: '超過設定天數的紀錄會被刪除',
    },
    {
      id: 'backupFrequencyDays',
      type: 'number',
      unit: '天',
      title: '備份頻率',
      icon: 'icon-refresh',
      description: '每隔幾天自動執行一次備份',
    },
    {
      id: 'backupTime',
      type: 'time',
      title: '備份時間點',
      icon: 'icon-remind-outline',
      description: '每次自動備份開始執行的時間',
    },
    {
      id: 'backupDays',
      type: 'number',
      unit: '天',
      title: '備份範圍',
      icon: 'icon-archive',
      description: '每次備份涵蓋最近幾天的紀錄',
    },
  ],
};
